import useStore from '../useStore';

const useSportsStore = (type) => {
  const { scoreStore } = useStore();

  return scoreStore[type];
};

export default useSportsStore;
